export default __webpack_public_path__ + "static/media/white-edit.b4b77702.svg";